export default "__VITE_ASSET__ZhtirC4ENZfjisomYZdNfQ__"